// Подключение свайпера
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);

const swiperProjects = new Swiper(".swiper-projects", {
  // loop: true,
  slidesPerView: 1,
  spaceBetween: 5,
  autoHeight: true, //enable auto height

  // Адаптивные настройки
  breakpoints: {
    // Для телефонов (ширина экрана < 768px)
    0: {
      slidesPerView: 1, // По одному слайду
    },
    // Для планшетов (ширина экрана >= 768px)
    768: {
      slidesPerView: 2, // По два слайда
    },
    // Для ПК (ширина экрана >= 1024px)
    1280: {
      slidesPerView: 3, // По три слайда
    },
  },

  // // Включаем навигацию (стрелки)
  // navigation: {
  //   nextEl: ".team-button-next",
  //   prevEl: ".team-button-prev",
  // },

  // Включаем пагинацию (точки)
  // pagination: {
  //   el: ".team-pagination",
  //   clickable: true, // Делаем точки кликабельными
  // },
});
